import ConfirmUser from './ConfirmUser'

export default ConfirmUser
